export default {
  title: 'Clique ou arraste o ficheiro para esta área para carregar',
  description: 'Formatos suportados: .csv, .xls, .xlsx',
  buttons: {
    download_template: 'Transferir modelo de importação',
  },
  toasts: {
    error: 'Falha ao carregar o ficheiro',
  },
};
